import { Avatar, Box, Button } from '@material-ui/core'
import styled, { keyframes } from 'styled-components/macro'


const pulseBlue = (shadow) => keyframes`
0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 ${shadow};
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
`

export const AnimatedAvatar = styled(Avatar)`
:hover{
    box-shadow: 0 0 0 0 ${props => props.theme.colors.primary};
    animation: ${pulseBlue(props => props.theme.colors.primary)} 2s infinite;
}
`
export const StyledLeftBox = styled(Box)<{ isDevice: boolean }>`
  display: flex;
  flex-direction: ${({ isDevice }) => (isDevice ? 'column' : 'row')};
  width: 100%;
  gap: 1em;
  height: auto;
  padding-top: 1em;
  justify-content: right;
  .market {
    order: ${({ isDevice }) => (isDevice ? 1 : 2)};
  }
  .posts {
    order: ${({ isDevice }) => (isDevice ? 2 : 1)};
  }
`
export const StyledCenterBox = styled(Box)`
display: flex;
  padding-top: 1em;
  justify-content: center;
  height: auto;

`
export const StyledResumeButton = styled(Button)`
    & .MuiButton-label {
      font-weight: bold;
      white-Space: nowrap;
    }
`

